<template>
	<div>
		<h2>Homepage</h2>
		<vx-card class="mt-5">
			<vs-tabs alignment="fixed">
				<vs-tab :label="$t('Corporativo')" v-if="user_role == 2 || user_role == 3" v-on:click="clearData()">
					<div class="mt-5">
						<div class="add-files-comp" v-if="i_files['corporate_files'].length == 0" v-on:click="addFiles('corporate_files')">
							<span class="text-input">{{$t('Nova')}}</span>
						</div>
						<label>
							<input type="file" id="files" ref="corporate_files" multiple v-on:change="handleFileUploads('corporate_files')"/>
						</label>

						<div class="my-5 flex flex-wrap w-1/1" v-if="i_files['corporate_files'].length > 0">
							<div class="w-1/3 mb-5 p-3" v-for="(file, key) in i_files['corporate_files']" :key="key">
								<img class="responsive upload_image" :src="generateImgPath(file)" alt="">
							</div>
							<div class="w-2/3 mb-5 p-3" v-for="(file, key) in i_files['corporate_files']" :key="key+1">
								<vs-input disabled class="w-full" :label="$t('nome')" v-model="file.name"/>

								<vs-input class="w-full" v-if="links[key]" :label="$t('Link')" v-model="links[key].link"/>

								<vs-select class="w-full" :placeholder="$t('SelecionarIdioma')" :label="$t('Idioma')" v-model="idiomas[key].idioma">
									<vs-select-item :key="lang" :text="lang" v-for="(lang, key) in langs" :value="key" />
								</vs-select>
							</div>
						</div>

						<div v-if="i_files['corporate_files'].length > 0">							
							<vs-button class="mr-3 sm:mb-0 mb-3" size="large" color="primary" type="filled"  v-on:click="submitFiles('corporate_files')">{{ $t('Gravar') }}</vs-button>

							<vs-button size="large" type="filled" color="danger" v-on:click="removeFile(0, 'corporate_files')">{{$t('cancels')}}</vs-button>
						</div>

						<vs-divider />

						<div v-if="corporate_images">
							<vs-collapse accordion type="margin">
								<vs-collapse-item v-for="(lang, lang_key) in corporate_images" :key="lang_key" v-if="lang.length > 0" icon-pack="feather" icon-arrow="icon-arrow-down">
								<div slot="header">
								<strong>{{lang_key}}</strong>
								<vs-divider class="my-0" />
								</div>
								<div class="flex flex-wrap">
									<div class="sm:w-full lg:w-1/5 p-2" v-for="(image, index) in lang" :key="index">
										<img class="responsive" :src="image.full_filepath" alt="">

										<vs-button class="w-full" type="border" color="danger" v-on:click="inactivateImage(image.id)">{{$t('remove')}}</vs-button>
									</div>
								</div>
								</vs-collapse-item>
							</vs-collapse>
						</div>
					</div>
				</vs-tab>

				<vs-tab :label="$t('hotel')" v-on:click="clearData()" v-if="user_role == 2 || user_role == 3 || user_role == 4">
					<div class="mt-5">
						<div class="hotel_dropdown">
							<hotelDropdown v-show="user.role != 4" v-bind:append_to_body="true" v-bind:current_stay="''" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
						</div>
						<div v-if="user_role == 4">
							<h3>{{ user.staff_info.hvg_desc }}</h3>
						</div>
						<div class="add-files-comp mt-5" v-if="i_files['hotel_files'].length == 0" v-on:click="addFiles('hotel_files')">
							<span class="text-input">{{$t('newa')}}</span>
						</div>
						<label>
							<input type="file" id="files" ref="hotel_files" v-on:change="handleFileUploads('hotel_files')"/>
						</label>

						<div class="my-5 flex flex-wrap w-1/1" v-if="i_files['hotel_files'].length > 0">
							<div class="w-1/3 mb-5 p-3" v-for="(file, key) in i_files['hotel_files']" :key="key">
								<img class="responsive upload_image" :src="generateImgPath(file)" alt="">
							</div>
							<div class="w-2/3 mb-5 p-3" v-for="(file, key) in i_files['hotel_files']" :key="key+1">
								<vs-input disabled class="w-full" :label="$t('nome')" v-model="file.name"/>

								<vs-input class="w-full" v-if="links[key]" :label="$t('Link')" v-model="links[key].link"/>

								<vs-select class="w-full" :placeholder="$t('SelecionarIdioma')" :label="$t('Idioma')" v-model="idiomas[key].idioma">
									<vs-select-item :key="lang" :text="lang" v-for="(lang, key) in langs" :value="key" />
								</vs-select>
							</div>
						</div>

						<div v-if="i_files['hotel_files'].length > 0">							
							<vs-button class="mr-3" size="large" color="primary" type="filled"  v-on:click="submitFiles('hotel_files')">{{$t('Gravar')}}</vs-button>

							<vs-button size="large" type="filled" color="danger" v-on:click="removeFile(0, 'hotel_files')">{{$t('cancels')}}</vs-button>
						</div>

						<vs-divider />

						<div v-if="hotel_images">
							<vs-collapse accordion type="margin">
								<vs-collapse-item v-for="(lang, lang_key) in hotel_images" :key="lang_key" v-if="lang.length > 0" icon-pack="feather" icon-arrow="icon-arrow-down">
								<div slot="header">
								<strong>{{lang_key}}</strong>
								<vs-divider class="my-0" />
								</div>
								<div class="flex flex-wrap">
									<div class="sm:w-full lg:w-1/5 p-2" v-for="(image, index) in lang" :key="index">
										<img class="responsive" :src="image.full_filepath" alt="">

										<vs-button class="w-full" type="border" color="danger" v-on:click="inactivateImage(image.id)">{{$t('remove')}}</vs-button>
									</div>
								</div>
								</vs-collapse-item>
							</vs-collapse>
						</div>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
	</div>
</template>

<script>

//load hotel dropdown from components
import HotelDropdown from '@/views/components/HotelDropdown.vue'

//load configurations on theme
import themeConfig from '@/../themeConfig.js';

export default {
  data() {
	return {
		links: [],
		idiomas: [],
		user: '',
		user_hotel_name: localStorage.getItem('user_hotel'),
		user: JSON.parse(window.localStorage.getItem('userSession')),
		changeHotel: '',
		corporate_images: '',
		hotel_images: '',
		i_files: {
			corporate_files: [],
			hotel_files: []
		},
		langs: {
			'PT': this.$t('PortuguêsPT'),
			'BR': this.$t('PortuguêsBR'), 
			'EN': this.$t('en'),
			'FR': this.$t('fr'), 
			'DE': this.$t('de'), 
			'ES': this.$t('es')
		},
		dimension_error: false,
		tmp_file: ''
	} 
  },
  methods: {
	/* generateImgPath(file) {
		return URL.createObjectURL(file);
	}, */

	clearData() {
		this.links = [];
		this.idiomas = [];
		this.i_files = {
			corporate_files: [],
			hotel_files: []
		};
		if(this.$refs['corporate_files']) {
			this.$refs['corporate_files'].value = '';
		}
		if(this.$refs['hotel_files']) {
			this.$refs['hotel_files'].value = '';
		}
	},

	checkImgDimensions(file) {
		let img = document.createElement("IMG");
		img.src = URL.createObjectURL(file);
		img.id = 'tmp_file';
		let tmp_img = document.body.appendChild(img);
	
		setTimeout(() => {
			if(tmp_img.naturalWidth != 500 && tmp_img.naturalHeight != 500) {
				this.dimension_error =  true;
			} else {
				this.dimension_error =  false;
				this.tmp_file = file;
			}

			document.getElementById("tmp_file").remove();
		}, 1000);
	},

	handleFileUploads(file_type) {
		// this.$vs.loading();

		let uploadedFiles = this.$refs[file_type].files;		
		
		//Adds the uploaded file to the files array
		for(let i = 0; i < uploadedFiles.length; i++) {
		    // Tests if the uploaded file has the right extension
			if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {

				this.checkImgDimensions(uploadedFiles[i]);

				if (uploadedFiles[i].size > 200000){
					this.$vs.notify({
						time: 4000,
						text: this.$t('O_tamanho_máximo_permitido_para_a_imagemé_de_200kb')+'.',
						color:'danger',
						position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
					});

					this.$refs[file_type].value = '';
					this.$vs.loading.close();
					return false;
				}

				setTimeout(() => {
					if(this.dimension_error == true) {
						this.$vs.notify({
							time: 4000,
							text: this.$t('As_dimensões_da_imagem_devem_ser_500px_x_500px_obrigatório')+'.',
							color:'danger',
							position:'bottom-right',
							iconPack: 'feather',
							icon:'icon-alert-triangle'
						});

						this.$refs[file_type].value = '';
						this.$vs.loading.close();
						return false;
					}
					this.links.push({link: ''});
					this.idiomas.push({idioma: ''});
					this.i_files[file_type].push(this.tmp_file);
					this.$vs.loading.close();
				}, 1000);
				this.$vs.loading.close();
			} else {
				this.$vs.notify({
					time: 4000,
					text: this.$t('Imagens_devem_ser_do_tipo_jpg_jpeg_png_ou_gif')+'.',
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				this.$vs.loading.close();
			}
			this.$vs.loading.close();
		}
		this.$vs.loading.close();
	},

	/*
     * Adds a file
     */  
	addFiles(file_type) {
		if (this.i_files[file_type].length > 0) {
			return;
		}
	
		this.$refs[file_type].click();
	},

	/*
	 * Removes a select file the user has uploaded
     */  
	removeFile(key, file_type) {
		this.i_files[file_type].splice(key, 1);
		this.links.splice(key, 1);
		this.idiomas.splice(key, 1);

		this.$refs[file_type].value = '';
	},

	/*
	 * Submit files to the server
	 */
	submitFiles(file_type) {
		if(this.idiomas[0].idioma == '') {
			this.$vs.notify({
				text: this.$('O_campo_Idioma_é_obrigatório')+'.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});

			return false;
		}

		if(file_type == 'hotel_files' && this.changeHotel == '') {
			this.$vs.notify({
				text: this.$('O_campo_Hotel_é_obrigatório')+'.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});

			return false;
		}

		this.$vs.loading();
		let formData = new FormData();
		let token = localStorage.getItem('usertoken');
		let that = this;

		/*
		 * Iterate over any file sent over appending the files
		 * to the form data.
		 */
		let file_count = 0;
		let files = [];
		for(let i = 0; i < this.i_files[file_type].length; i++) {
		  file_count++;

		  formData.append('file_' + i, this.i_files[file_type][i]);
		}
		formData.append('file_count', file_count);
		
		formData.append('links', JSON.stringify(this.links));
		formData.append('idiomas', JSON.stringify(this.idiomas));
		
		// Appends data that's needed to identify files
		formData.append('file_type', file_type);
		formData.append('new_hotel', this.changeHotel);
		formData.append('current_hotel', this.user_hotel_name);

		this.$api.post('/myvilagale/admin/banner-images?token=' + localStorage.getItem('usertoken'),
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
			}
		}).then(function(res) {
			if(that.changeHotel != '') {
				that.getHotelImages(that.changeHotel);
			}			
			that.getCorporateImages();

			that.$vs.loading.close();
			that.clearData();

			that.$vs.notify({
				text: this.$t('Registo_criado_com_sucesso')+'.',
				color:'success',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-check'
			});
		})
		.catch(function(err) {
			that.$vs.loading.close();
			that.$vs.notify({
				text: this.$t('Ocorreu_um_erro_ao_criar_o_registo')+'.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});
		});                    
	},
	getCorporateImages() {
		this.$vs.loading();
		let that = this;
		let token = localStorage.getItem('usertoken');
		let corpImages = [];

		this.$api({
			method: 'get',
			url: themeConfig.apiurl + '/myvilagale/corporate-images',
			headers: {
				Authorization: 'Bearer ' + token
			}
		})
		.then(function (res) {
			that.$vs.loading.close();
			that.corporate_images = res.data;
		})
		.catch(function(err) {
			that.$vs.loading.close();
			that.$vs.loading.close();
		});  
	},
	getHotelImages(hotel) {
		this.$vs.loading();
		let that = this;
		let token = localStorage.getItem('usertoken');
		let hotelImages = [];

		this.$api({
			method: 'get',
			url: themeConfig.apiurl + '/myvilagale/hotel-images',
			headers: {
				Authorization: 'Bearer ' + token
			},
			params: {
				new_hotel: hotel
			}
		})
		.then(function (res) {
			that.$vs.loading.close();
			that.hotel_images = res.data;
		})
		.catch(function(err) {
			that.$vs.loading.close();
		});  
	},
	inactivateImage(image_id) {
		this.$vs.loading();
		let that = this;
		let token = localStorage.getItem('usertoken');
		let hotelImages = [];

		this.$api.delete('/myvilagale/admin/delete/image/' + image_id + '?token=' + localStorage.getItem('usertoken'),
		{
			headers: {
				Authorization: 'Bearer ' + token
			},
		})
		.then(function (res) {
			that.getCorporateImages();

			if(that.changeHotel != '') {
				that.getHotelImages(that.changeHotel);
			}

			that.$vs.loading.close();

			that.$vs.notify({
				text: this.$t('Registo_eliminado_com_sucesso')+'.',
				color:'success',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-check'
			});
		})
		.catch(function(err) {
			that.$vs.loading.close();
			that.$vs.notify({
				text: this.$t('Ocorreu_um_erro_ao_eliminar_o_registo')+'.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});
		}); 
	},
	onChangeHotel(newHotel) {
		this.changeHotel = newHotel;
		this.getHotelImages(newHotel);
	},
  },
  created: function() {
	this.user_role = this.user.role;
  },
  mounted() {
	  this.getCorporateImages();
	  let user = JSON.parse(localStorage.getItem('userSession'));
	  if (user.role == 4 && user.staff_info.hvg_id) {
		  this.changeHotel = user.staff_info.hvg_id;
		  this.getHotelImages(user.staff_info.hvg_id);
	  }
  },
  components: {
	HotelDropdown,
  }
}

</script>

<style scoped>
	#tmp_file {
        display: none !important;
    }

	.upload_image {
		border: 2px solid rgba(0,0,0,.4);
	}

	.admin_manager_only {
		margin-top: 25px;
	}

	.dropdown {
		margin-top: 25px;
	}

	.options_block {
		display: flex;
	}

	.element_button {
		margin-top: 19px;
	}

	.current_hotel {
		margin-top: 25px;
	}

	.carousel {
		margin-top: 25px;
	}

    input[type="file"]{
		position: absolute;
		top: -500px;
    }

	.add-files-comp {
		background: #f5f5f5;
		width: 180px;
		height: 50px;
		box-sizing: border-box;
		border-radius: 8px;
		position: relative;
		transition: all .25s ease;
		border: 1px dashed rgba(0,0,0,.1);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		cursor: pointer;
	}

	.add-files-comp .text-input {
		min-width: 200px;
		display: block;
		text-align: center;
		margin: 0!important;
		padding: 0!important;
		width: 100%;
		font-weight: 700;
	}

	  div.file-listing{
		width: 400px;
	  }

	  span.remove-file{
		color: red;
		cursor: pointer;
		float: right;
	  }

	  .con-img-upload {
		width: 100%;
		background: #fff;
		margin-top: 5px;
		padding-right: 5px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-column-gap: 5px;
		-moz-column-gap: 5px;
		column-gap: 5px;
	  }

	  .vs-collapse-item {
		  background: #f7f7f7;
	  }
</style>
